const baseClaim = {
  claimDate: '2021-09-15',
  claimId: '2203186',
  claimType: 'fuel',
  statusName: 'InProgress',
  total: '22.00'
};

export default {
  data: {
    claimsByStatus: [
      { ...baseClaim },
      {
        ...baseClaim,
        claimId: '2203187',
        fileIds: ['90f48352-4c7e-4e86-9313-97ccf54611a1']
      },
      {
        ...baseClaim,
        claimId: '2203188',
        total: '25.32',
        claimDate: '2021-02-03',
        fileIds: [
          '90f48352-4c7e-4e86-9313-97ccf54611a1',
          '67b15b17-9e71-4e96-9953-86bb7e69973b'
        ]
      },
      { ...baseClaim, claimId: '2203189', statusName: 'Approved' },
      { ...baseClaim, claimId: '2203180', claimType: 'tyres', total: '54.43' },
      { ...baseClaim, claimId: '2203181', claimType: 'maintenance' },
      { ...baseClaim, claimId: '2203182' },
      { ...baseClaim, claimId: '2203183', statusName: 'Approved' },
      { ...baseClaim, claimId: '2203184', statusName: 'OnHold' },
      { ...baseClaim, claimId: '2203185' },
      { ...baseClaim, claimId: '2203190', claimType: 'insurance' }
    ]
  }
};
